
import Explore from '../Explore/Explore'
import Profile from './Profile'
import RightSection from './RightSection'
import axios from 'axios';
import React, { useState, useEffect, useCallback } from 'react'
import { getData, setData } from "../helper/localStorage";
// import profile from './profile.json'
// import explore from './explore.json'

const ProfileExplore = ({ match }) => {
    // const [loading, setLoading] = useState(false);
    //  const [profileData, setProfileData] = useState(profile);
    // const [exploreData, setExploreData] = useState(explore);

    const [profileData, setProfileData] = useState({});
    const [exploreData, setExploreData] = useState({});
    const [loading, setLoading] = useState(true);
    const loadData = useCallback(() => {
       let id = match.params.userId
        const apiUrl1 = encodeURI(`https://millonabe.herokuapp.com/userinfo?userid=${id}`);
        const apiUrl2 = encodeURI(`https://millonabe.herokuapp.com/recommendedProfiles?userid=${id}`);
        axios.all([
            axios.get(apiUrl1),
            axios.get(apiUrl2)
        ])
            .then(axios.spread((res1, res2) => {
                setProfileData(res1.data);
                setExploreData(res2.data)
                setLoading(false);
            }));
    }, []);

    useEffect(() => {
        loadData()
    }, [loadData])

    
    return (
        <>{(loading) ? (<h5>Loading</h5>)   : (
            <div className="px-5 py-1 p-lg-0 bg-surface-secondary">
            <div className="d-flex justify-content-center">
                <div className="col-lg-5 col-xl-4 p-6 p-xl-20 position-fixed start-0 top-0 h-screen overflow-y-hidden bg-primary d-none d-lg-flex flex-column">
                    {/* Logo */}
                    <a className="d-flex" href="#">
                        <img
                            src="https://i.ibb.co/52NvQB3/2462345.png"
                            className="h-10"
                            alt="..."
                        />
                        <h5 style={{ marginLeft: '10px' }}> FINder</h5>

                    </a>
                    {/* Title */}
                    <div className="mt-5 mb-10">
                        <h1 className="ls-tight font-bolder display-6 text-white mb-5">
                            Hey ! We have find Potential Partner for you
    </h1>
                        <p className="text-white text-opacity-80">
                            Check Explore section to view more
    </p>
                    </div>
                    {/* Circle */}

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="red" viewBox="0 0 24 24" className="w-56 h-56 position-absolute bottom-0 end-20 transform translate-y-1/3 rotate-60" transform='rotate(45)'><path d="M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z" /></svg>

                </div>
                <div className="col-12 col-md-9 col-lg-7 offset-lg-3 border-left-lg min-h-lg-screen d-flex flex-column pt-3 px-lg-5 ">

                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-xl-12 ">
                            {/* <div className="mt-4">
                     
                                <h1 className="ls-tight font-bolder h2"></h1>
                            </div> */}
                            <RightSection profile={profileData} explore={exploreData} />


                        </div>
                    </div>
                </div>
            </div>
        </div>

 
        )
      

        }
      </>
    )
}

export default ProfileExplore
